import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './ignoreUserModal.scss';

interface IIgnoreUserModalProps {
    onCloseClick(): void;
    onConfirmClick(): void;
}

export class IgnoreUserModal extends React.Component<IIgnoreUserModalProps> {

    constructor(props: IIgnoreUserModalProps) {
        super(props);
        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
    }

    render(): React.ReactNode {
        return (
            <ConfirmationModal
                className="ignore-user-modal"
                message={this.renderModalBody()}
                onCancel={this.handleCloseClick}
                onClose={this.handleCloseClick}
                onConfirm={this.handleConfirmClick}
                title="Ignore User"
                confirmMessage="Ignore User"
            />
        );
    }

    renderModalBody(): React.ReactNode {
        const headerText = 'Managers who are ignored will not be added as a Team user and will not' +
            ' be able to login to Team. You may add this user to the product in the future within' +
            ' Insight Lab.';
        return (
            <div className="ignore-user-modal__body">
                {headerText}
            </div>
        );
    }

    handleCloseClick(): void {
        this.props.onCloseClick();
    }

    handleConfirmClick(): void {
        this.props.onConfirmClick();
    }
}

export default { IgnoreUserModal };